import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { LegalDocumentLinksWithModal } from "./LegalDocumentLinksWithModal";

type Props = {
  open: boolean;
  isFirstAcceptancePrompt: boolean;
  accepting: boolean;
  onAccept: () => void;
  onLater: () => void;
};

export function LegalAcceptanceSoftDialog({
  open,
  isFirstAcceptancePrompt,
  accepting,
  onAccept,
  onLater,
}: Props) {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onLater}>
      <DialogTitle>
        {isFirstAcceptancePrompt ? "Terms and privacy" : "Updated legal documents"}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {isFirstAcceptancePrompt
            ? "Please read and accept our Terms of Service and Privacy Policy when you have a moment. You can open them below. Until they take full effect, you may tap Later and keep using the app."
            : "New Terms of Service and/or Privacy Policy will apply soon. Please review them before the effective date."}
        </Typography>
        <LegalDocumentLinksWithModal />
      </DialogContent>
      <DialogActions>
        <Button onClick={onLater}>Later</Button>
        <Button onClick={onAccept} variant="contained" disabled={accepting}>
          I have read and agree
        </Button>
      </DialogActions>
    </Dialog>
  );
}
